import { HomeOutlined, PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { AppHeader, ColumnLayout } from '@/components'
import { useGetViewerQuery } from '@/generated/graphql'
import { GroupCreateEdit } from '@/modules/group/group-create-edit'
import { UserManage } from '@/modules/user/user-manage/user-manage.component'
import { routes } from '@/routes'

import s from './user-manage.module.less'

export const UserManageContainer = () => {
  const { t } = useTranslation()
  const { data } = useGetViewerQuery()
  const history = useHistory()

  const followByDep = (
    <Button type='primary' onClick={() => history.push(routes.tools.departments())} icon={<PlusOutlined />}>
      {t('follow.followByDep')}
    </Button>
  )

  const createdGroup = (
    <GroupCreateEdit>
      <Button type='primary' icon={<PlusOutlined />}>
        {t('groups.createGroup')}
      </Button>
    </GroupCreateEdit>
  )

  const actions = (
    <div className={s.headerActions}>
      {followByDep}
      {createdGroup}
    </div>
  )

  const header = <AppHeader title={t('home.my')} avatar={<HomeOutlined style={{ fontSize: 24 }} />} actions={actions} />

  const middle = <UserManage userId={data!.viewer.userId} />

  return <ColumnLayout header={header} middle={middle} />
}
